import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { downloadExport } from "@/lib/api";

export default function ExportButton({ module, label = "Export CSV", testId, variant = "outline", className = "" }) {
  const handle = () => {
    downloadExport(module);
    toast.success(`Downloading ${module}.csv`);
  };
  return (
    <Button
      type="button"
      variant={variant}
      onClick={handle}
      className={className}
      data-testid={testId || `export-${module}`}
    >
      <Download size={16} className="mr-2" />
      {label}
    </Button>
  );
}
